import {
  CURRENT_NOTIFICATION, DECREMENT_NEW_NOTIFS_COUNT,
  MP_NOTIFICATION_LIST, MP_REQUESTED_BY, NEW_NOTIFICATIONS, UNREAD_NOTIFICATIONS,
  // SEARCHED_NOTIFICATIONS,
} from './types';
import notifIsNotExpired from '../../../utils/checkNotificationActivity';

export default {
  [MP_NOTIFICATION_LIST]: (state, { mPInvitationList, next }) => {
    state.mPInvitationList = [...mPInvitationList];
    state.newMPInvitationCount = mPInvitationList.filter(notif => !notif.is_proceeded && notifIsNotExpired(notif)).length;
    state.mpInvitationNextPage = next;
  },
  [MP_REQUESTED_BY]: (state, payload) => {
    state.mPRequestedBy = payload.mPRequestedBy;
  },
  [NEW_NOTIFICATIONS]: (state, { results, count }) => {
    state.allNotifications = results;
    state.allNotifsCount = count;
    state.newNotifications = results.filter(notif => !notif.is_read);
    state.readNotifications = results.filter(notif => notif.is_read);
  },
  [CURRENT_NOTIFICATION]: (state, { notif }) => {
    state.currentNotification = notif;
  },
  [DECREMENT_NEW_NOTIFS_COUNT]: (state) => {
    state.newNotifsCount -= 1;
  },
  [UNREAD_NOTIFICATIONS]: (state, { count }) => {
    state.newNotifsCount = state.newMPInvitationCount;
    state.newNotifsCount += count;
  },
  // [SEARCHED_NOTIFICATIONS]: (state, { results }) => {
  //   state.searchedNotifications = results;
  // },
};
